import { useState, useContext, createContext } from 'react';

const CabinetContext = createContext();

export const useCabinetMenu = () => {
  return useContext(CabinetContext);
};

export const CabinetProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(0);
  const [activeAddAccount, setActiveAddAccount] = useState(false);

  const handleTabClick = (index) => {
    setActiveMenu(index);
    setActiveAddAccount(false);
  };

  const value = {
    activeMenu,
    activeAddAccount,
    handleTabClick,
    setActiveAddAccount,
    setActiveMenu,
  };

  return (
    <CabinetContext.Provider value={value}>{children}</CabinetContext.Provider>
  );
};
